// Local translations
export const T = {
  en_GB: {
    name: "Name",
    type: "Type",
    appliesTo: "Applies To",
    tab: "Tab",
    visibleInList: "Visible in List",
    visibleInProfile: "Visible in Profile",
    actions: "Actions",
    edit: "Edit",
    standard: "(Standard)",
    cannotEdit: "Cannot edit",
    alwaysVisible: "Always visible",
    notApplicable: "N/A",
    noFieldsYet: "No custom fields yet. Create your first custom field to get started.",
    defaultTab: "Default",
    typeText: "Text",
    typeTextarea: "Textarea",
    typeNumber: "Number",
    typeDate: "Date",
    typeDateTime: "Date and time",
    typeDropdown: "Dropdown",
    typeRadio: "Radio buttons",
    typeMultiselect: "Multi-select (checkboxes)",
    typeBoolean: "Checkbox (yes/no)",
    typeUser: "User",
    person: "Person",
    company: "Company",
    group: "Group",
    allTypes: "All",
    deleteCustomField: "Delete Custom Field",
    deleteConfirmation: (name: string) =>
      `Are you sure you want to delete "${name}"? This will also delete all data associated with this field.`,
    delete: "Delete",
    cancel: "Cancel",
    error: "Error",
    failedToAssignTab: "Failed to assign tab",
    failedToToggleVisibility: "Failed to toggle visibility",
    failedToDelete: "Failed to delete custom field",
  },
  nb_NO: {
    name: "Navn",
    type: "Type",
    appliesTo: "Gjelder for",
    tab: "Fane",
    visibleInList: "Synlig i liste",
    visibleInProfile: "Synlig i profil",
    actions: "Handlinger",
    edit: "Rediger",
    standard: "(Standard)",
    cannotEdit: "Kan ikke redigere",
    alwaysVisible: "Alltid synlig",
    notApplicable: "N/A",
    noFieldsYet: "Ingen egendefinerte felt ennå. Opprett ditt første felt for å komme i gang.",
    defaultTab: "Standard",
    typeText: "Tekst",
    typeTextarea: "Tekstområde",
    typeNumber: "Tall",
    typeDate: "Dato",
    typeDateTime: "Dato og klokkeslett",
    typeDropdown: "Nedtrekksliste",
    typeRadio: "Radioknapper",
    typeMultiselect: "Flervalg (avkrysningsbokser)",
    typeBoolean: "Avkrysningsboks (ja/nei)",
    typeUser: "Bruker",
    person: "Person",
    company: "Selskap",
    group: "Gruppe",
    allTypes: "Alle",
    deleteCustomField: "Slett egendefinert felt",
    deleteConfirmation: (name: string) =>
      `Er du sikker på at du vil slette "${name}"? Dette vil også slette alle data knyttet til dette feltet.`,
    delete: "Slett",
    cancel: "Avbryt",
    error: "Feil",
    failedToAssignTab: "Kunne ikke tilordne fane",
    failedToToggleVisibility: "Kunne ikke endre synlighet",
    failedToDelete: "Kunne ikke slette egendefinert felt",
  },
} as const;
